<template>
  <div id="app">
    <router-view v-if="configDone"/>
    <qr-code v-if="initDone"></qr-code>
  </div>
</template>
<script>
import VConsole from 'vconsole'
import bus from '@/utils/bus'
(process.env.VUE_APP_WEB === 'local') && new VConsole()
import {
  mapMutations, mapState
} from 'vuex'
import {
  getConfigService
} from '@/api'

export default {
  data () {
    return {
      curWechatUser: {},
      initDone: false,
      configDone: false
    }
  },
  computed: {
    ...mapState(['serviceConfig'])
  },
  components: {
    QrCode: () => import('@/components/qrcode/index.vue')
  },
  async created() {
    console.log('app.vue created 执行')
    const res = await getConfigService()
    document.title = res.projectName
    this.configDone = true
    this.SET_SERVICE_CONFIG(res)
    this.$wechat.init(res)
    await Promise.all([this.getWechatUser(), this.$wechat.ready()])
    console.log('await app.vue 后面微任务执行')
    await this.$wechat.ready()
    await this.wechatConfig()
    this.$wechat.hideMenuItems({
      menuList: ['menuItem:copyUrl']
    })
    this.$store.commit('SET_WX_CONFIG_SUCCESS', true)
    this.initDone = true
  },
  methods: {
    ...mapMutations(['SET_WECHAT_USER', 'SET_SERVICE_CONFIG']),
    async getWechatUser() {
      this.curWechatUser = await this.$wechat.getUserInfo(this.serviceConfig)
      // console.log(this.curWechatUser, '------9999999999')
      if (this.curWechatUser) {
        this.SET_WECHAT_USER(this.curWechatUser)
        this.$root.$emit('userReady')
        this.$behavior.init(Object.assign({}, this.curWechatUser, {
          project: this.serviceConfig.project,
          projectName: this.serviceConfig.projectName,
          channel: this.serviceConfig.channel,
        }))
        this.$sa.init({
          userId: this.curWechatUser.userId,
          platform: this.serviceConfig.projectName,
        }, this.curWechatUser)
        bus.$emit('sa inited')
      } else {
        return false
      }
    },
    async wechatConfig() {
      await this.$wechat.config(() => {
          this.$store.commit('SET_WX_CONFIG_SUCCESS', true)
        }
      )
    }
  }
}
</script>

<style>
#app {
  -webkit-overflow-scrolling: touch;
  height: 100%;
  margin: 0 auto!important;
  background-color: #f2f2f2;
}
.loading {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: url('./assets/loading.gif') no-repeat center;
  background-size: .8rem;
  z-index: 1;
  top: 0;
  background-color: #ffffff;
}

</style>
